<header>
    <app-menu-bar></app-menu-bar>
</header>
<router-outlet></router-outlet>
